import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractCsvExportService } from '../common/file/abstract-csv-export.service';
import { FileSaverService } from '../common/file/file-saver.service';
import { FileSaverUsecase } from '../../domain/model/file-saver-usecase.enum';


@Injectable({
    providedIn: 'root',
})
export class DatenabfrageExportService extends AbstractCsvExportService {
    protected http: HttpClient;
    protected fileSaverService: FileSaverService;

    constructor() {
        const http = inject(HttpClient);
        const fileSaverService = inject(FileSaverService);

        super(http, fileSaverService);

        this.http = http;
        this.fileSaverService = fileSaverService;
    }

    public exportAktiveDatenabfrage(datenabfrageId: number) {
        this.exportCsv(`/datenabfrage/aktive/${datenabfrageId}/datenabfrage.csv`, FileSaverUsecase.CSV_EXPORT_AKTIVE_DATENABFRAGE);
    }

    public exportArchivierteDatenabfrage(datenabfrageId: number) {
        this.exportCsv(`/datenabfrage/archivierte/${datenabfrageId}/datenabfrage.csv`, FileSaverUsecase.CSV_EXPORT_ARCHIVIERTE_DATENABFRAGE);
    }
}
